import { useEffect, useState } from 'react'
import { subscribe, BulkUploadDocumentProgress } from 'src/lib/bulkUploadDocumentProgress'
import { Loader, Progress, Alert } from '@mantine/core'

const BulkUploadDocumentProgressNotification = () => {
  const [progress, setProgress] = useState<BulkUploadDocumentProgress | null>(null)

  useEffect(() => {
    const unsubscribe = subscribe((newProgress) => {
      setProgress(newProgress)
    })

    return () => unsubscribe()
  }, [])

  if (!progress || !progress.isActive) {
    return null
  }

  const failedFiles = progress.files.filter((f) => f.status === 'failed')
  const progressPercent = (progress.completedCount / progress.totalCount) * 100

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 max-w-md rounded-lg border border-doubleNickel-brand-200 bg-white p-4 shadow-lg">
      <div className="mb-3 flex items-center gap-2">
        <Loader size="sm" />
        <span className="text-sm font-medium text-doubleNickel-gray-700">
          Bulk uploading files
        </span>
      </div>

      <Progress
        value={progressPercent}
        size="sm"
        className="mb-2"
        label={`${progress.completedCount} of ${progress.totalCount} files`}
      />

      <p className="text-xs text-doubleNickel-gray-600 mb-2">
        Don't refresh. You can navigate to other parts of the application.
      </p>

      {failedFiles.length > 0 && (
        <Alert
          title={`${failedFiles.length} file${failedFiles.length !== 1 ? 's' : ''} failed`}
          color="red"
          variant="light"
          className="mt-2 text-xs"
        >
          <ul className="list-inside list-disc">
            {failedFiles.map((f, idx) => (
              <li key={idx} title={f.error} className="truncate">
                {f.file.name}: {f.error}
              </li>
            ))}
          </ul>
        </Alert>
      )}
    </div>
  )
}

export default BulkUploadDocumentProgressNotification
